import {Directive, HostListener, inject} from '@angular/core';
import {Router, RouterLink} from "@angular/router";

@Directive({
  selector: '[routerLink], a[routerLink]',
  standalone: true
})
export class RouterLinkDirective extends RouterLink {
  private navigatorService = inject(Router);
  private mouseDownX = 0;
  private mouseDownY = 0;
  private readonly DRAG_THRESHOLD = 5;

  @HostListener('document:mousedown', ['$event'])
  recordMouseDown(ev: MouseEvent) {
    this.mouseDownX = ev.clientX;
    this.mouseDownY = ev.clientY;
  }

  @HostListener('mouseup', ['$event'])
  triggerCustomClick(ev: MouseEvent) {
    const dx = ev.clientX - this.mouseDownX;
    const dy = ev.clientY - this.mouseDownY;
    if (Math.sqrt(dx * dx + dy * dy) > this.DRAG_THRESHOLD) {
      return;
    }

    if (ev.button === 1 || ((ev.ctrlKey || ev.metaKey) && ev.button === 0)) {
      window.open(this.urlTree!.toString(), '_blank');
      ev.preventDefault();
    } else if (ev.button === 0) {
      this.navigatorService.navigateByUrl(this.urlTree!);
      ev.preventDefault();
    }
  }

  @HostListener('mousedown', ['$event'])
  preventMiddleClickScroll(ev: MouseEvent) {
    if (ev.button === 1) {
      ev.preventDefault();
    }
  }

}
